// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"2e987358","52":"3a879803","53":"08216918","197":"f54f6d1c","337":"db159c55","477":"3d2bc78b","587":"2ba693e2"}[chunkId] + ".js";
};